import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const W8BENFormSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="W8BENFormSection"
      title={t(`client.client.${formProps.formType}.title`)}
    >
      <FormContent {...formProps} />
    </Section>
  );
};
